import { useNavigationBlocker } from '../../../../../hooks/useNavigationBlocker';
import { confirmUnsavedChanges } from '../model/workScheduleConfirmations';

export const useWorkScheduleNavigationBlocker = ({
  hideDirtyWorkScheduleForms,
  shouldBlockNavigation,
  skipNextNavigationBlockRef,
}) => {
  useNavigationBlocker(
    shouldBlockNavigation,
    ({ location, unblock, history }) => {
      if (skipNextNavigationBlockRef.current) {
        skipNextNavigationBlockRef.current = false;
        unblock();
        history.push(location);
        return;
      }

      confirmUnsavedChanges({
        title: 'Вы уверены, что хотите покинуть страницу?',
        onOk: () => {
          hideDirtyWorkScheduleForms();
          unblock();
          history.push(location);
        },
      });
    }
  );
};
